export default __webpack_public_path__ + "static/media/01.7119a30f.jpg";